import styles from '../styles/NetworkError.module.scss'

function SiteNotFound() {
	return (
		<div className={styles.networkError}>
			<h1>Site not found</h1>
			<p>We could not find a site for this address. Please check the URL and try again.</p>
		</div>
	)
}

export default SiteNotFound;
